import React, { useState } from "react";
import Header from "../Header/Header";
import SideBar from "../SideBar/SideBar";
import Footer from "../Footer/Footer";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  Typography,
  IconButton,
} from "@mui/material";
import { ArrowRight, ArrowDropDown } from "@mui/icons-material";
import styles from "./statement.module.css";
import TransactionFilter from "../TransactionFilter/TransactionFilter";

const Statement = () => {
  const dummyData = [
    {
      utr: "UTR001",
      date: "2025-04-15",
      contactName: "Invoice #123",
      debit: 150.75,
    },
    {
      utr: "UTR002",
      date: "2025-04-14",
      contactName: "Payment Receipt",
      debit: 200.0,
    },
    {
      utr: "UTR003",
      date: "2025-04-13",
      contactName: "Contract Agreement",
      debit: 99.99,
    },
    {
      utr: "UTR004",
      date: "2025-04-12",
      contactName: "Expense Report",
      debit: 300.25,
    },
    {
      utr: "UTR005",
      date: "2025-04-11",
      contactName: "Tax Document",
      debit: 50.0,
    },
  ];
  const [dataSource, setDataSource] = useState(dummyData);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [search, setSearch] = useState("");

  const columns = [
    {
      id: "date",
      label: "Date",
      width: "20%",
      format: (value) => new Date(value).toLocaleDateString(),
    },
    {
      id: "contactName",
      label: "File",
      width: "40%",
    },
    {
      id: "debit",
      label: "Action",
      width: "40%",
      format: (value) => value.toFixed(2),
    },
  ];

  return (
    <div>
      {/* <Header /> */}
      <div className={`${styles.frameParent} mt-4 justify-content-between`}>
        <div className={styles.saveMoney1044644423Parent}>
          <div className={`${styles.saveMoney1044644423} m-2`}>
            <img className={styles.vectorIcon} alt="" src="/vector.svg" />
          </div>
          <div className={styles.availableBalanceParent}>
            <div className={styles.availableBalance}>Available Balance*</div>
            <div className={styles.div}>{"0"}</div>
          </div>
        </div>
      </div>
      <TransactionFilter page="statement" setSearch={setSearch} />
      <Box className={styles.centerPage}>
        <TableContainer
          component={Paper}
          sx={{ flexGrow: 1, overflow: "auto" }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="statement table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sx={{
                      width: column.width,
                      fontWeight: "bold",
                      fontSize: "16px",
                      fontFamily: "sarabun",
                      backgroundColor: "#F3F4F7",
                      textAlign: "center",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataSource.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <Typography sx={{ py: 2, color: "#666" }}>
                      No transactions available
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                dataSource.map((row) => {
                  const isExpanded = expandedRowKeys.includes(row.utr);
                  return (
                    <React.Fragment key={row.utr}>
                      <TableRow
                        hover
                        sx={{ cursor: "pointer" }}
                        // onClick={() => onRowClick(row)}
                      >
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            sx={{
                              width: column.width,
                              fontSize: "14px",
                              fontFamily: '"Roboto", sans-serif',
                              textAlign: "center",
                            }}
                          >
                            {column.id === "expandIcon" ? (
                              <IconButton size="small">
                                {isExpanded ? (
                                  <ArrowDropDown />
                                ) : (
                                  <ArrowRight />
                                )}
                              </IconButton>
                            ) : column.format ? (
                              column.format(row[column.id])
                            ) : (
                              row[column.id] || "N/A"
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

export default Statement;
